<template>
  <div class="commodity-application-container">
    <div class="section-header">
      <div class="header-left">
        <h2 class="title">标外商品采购申请</h2>
        <span class="sub-title">目录外特需科研物料、进口耗材与定制商品立项申请全流程流转</span>
      </div>
      <el-button type="primary" icon="el-icon-plus" class="btn-create" @click="handleOpen()">
        新增标外商品申请
      </el-button>
    </div>

    <!-- 加载骨架屏 -->
    <div v-if="loading" class="order-skeleton-list">
      <div v-for="i in 3" :key="i" class="sk-order-card">
        <div class="sk-header">
          <div class="sk-bar w-30"></div>
          <div class="sk-bar w-20"></div>
        </div>
        <div class="sk-body">
          <div class="sk-details">
            <div class="sk-bar w-60"></div>
            <div class="sk-bar w-40"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 申请记录表格 -->
    <div class="orderBox" v-else-if="orderList && orderList.length > 0">
      <div class="orderTableHeader">
        <span class="col-status">审批状态</span>
        <span class="col-goods">申请商品名称</span>
        <span class="col-spec">规格要求</span>
        <span class="col-price">预计单价</span>
        <span class="col-reason">申请原因与采购理由</span>
      </div>

      <ul class="orderList">
        <li v-for="item in orderList" :key="'order' + item.id" class="order-card-item">
          <div class="orderDetail">
            <span class="col-status">
              <span class="status-badge" :class="getStatusClass(item.mx1whh7fbp1ozmov)">
                {{ findStatusLabel(item.mx1whh7fbp1ozmov) }}
              </span>
            </span>

            <div class="goodsName">
              <p class="goods-title">{{ item.yweggjdjennwlx2b }}</p>
              <span class="brand-text" v-if="item['2uxq3bkljctevagu']">
                品牌: {{ item['2uxq3bkljctevagu'] }}
              </span>
            </div>

            <span class="col-spec">{{ item.okxizq5fy7x1v2pj || '通用标准' }}</span>
            <span class="col-price">￥{{ item.wxym5do3isvbzeth || 0 }}</span>
            <span class="col-reason" :title="item['g9llk5yvei0jvr6x']">
              {{ item['g9llk5yvei0jvr6x'] }}
            </span>
          </div>
        </li>
      </ul>

      <!-- 分页组件 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 40, 80]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 规范空状态 -->
    <div class="empty-gov-state" v-else>
      <div class="icon-circle">
        <i class="el-icon-document-add"></i>
      </div>
      <p class="empty-title">暂无标外商品申请记录</p>
      <p class="empty-sub">若系统当前标准品库中没有所需型号，可点击右上角发起标外商品定制申请</p>
    </div>

    <!-- 新增标外商品申请弹窗 -->
    <el-dialog
      title="新增标外商品采购申请"
      :visible.sync="dialogVisible"
      width="780px"
      custom-class="gov-address-dialog"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="100px"
        size="medium"
        class="application-form"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="收货人" required>
              <el-select
                v-model="form.orac6eyyydzpco13"
                placeholder="请选择常用收货人"
                @change="changeAddress"
                filterable
                style="width: 100%;"
              >
                <el-option
                  v-for="item in addressList"
                  :key="item.id"
                  :label="item.mdbcej4opshigmrs + (item['3ulvzh2pgygl0vga'] ? ' (工号: ' + item['3ulvzh2pgygl0vga'] + ')' : '')"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话">
              <el-input
                v-model="form.etnsg3kbzcknkawr"
                disabled
                placeholder="自动带出联系方式"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="所在地区">
              <el-cascader
                disabled
                v-model="form.glhztcnef0v5zdcy"
                :options="city"
                :props="props"
                placeholder="自动带出省市区"
                style="width: 100%;"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址">
              <el-input
                v-model="form['5swsm1dvrchwdg3v']"
                disabled
                placeholder="自动带出详细地址"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商品名称" required>
              <el-input
                v-model="form.yweggjdjennwlx2b"
                placeholder="请输入申请采购的商品物料名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="品牌名称">
              <el-input
                v-model="form['2uxq3bkljctevagu']"
                placeholder="请输入指定品牌（若无则填通用）"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="规格要求">
              <el-input
                v-model="form.okxizq5fy7x1v2pj"
                placeholder="请输入详细型号、纯度或包装规格"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="预计单价" required>
              <el-input
                v-model="form.wxym5do3isvbzeth"
                placeholder="元"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="需求数量" required>
              <el-input
                v-model="form['2lcyfkgbyjmfmedh']"
                placeholder="数量"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="采购链接">
          <el-input
            v-model="form['5wzakr37o7owu4qj']"
            placeholder="若有原厂参考页面或电商链接可粘贴于此"
          ></el-input>
        </el-form-item>

        <el-form-item label="申请采购理由" required>
          <el-input
            type="textarea"
            :rows="2"
            v-model="form.g9llk5yvei0jvr6x"
            placeholder="请详细说明科研项目背景、用途及标外申购的必要性"
          ></el-input>
        </el-form-item>

        <el-form-item label="物料图样">
          <div class="fileList">
            <div
              class="fileItem"
              v-for="(item, index) in file"
              :key="index"
            >
              <div class="close" @click="handleRemove(item)">
                <i class="el-icon-close"></i>
              </div>
              <img :src="item.url" alt="" class="url" />
            </div>
            <div class="fileItem uploader">
              <el-upload
                :action="action"
                list-type="picture-card"
                :on-remove="handleRemove"
                :file-list="file"
                :show-file-list="false"
                :on-success="handleSuccess"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submit()">提交立项申请</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { online, postOnline } from "@/api/platform";
import city from '@/util/city';

export default {
  name: "CommodityApplication",
  computed: {
    ...mapState(["clientToken"]),
  },
  data () {
    return {
      id: '',
      form_head_uuid: "d098b98521634ac7aac59d4d4ed249e6",
      orderList: [],
      keyword: '',
      loading: true,
      submitLoading: false,
      page: 1,
      total: 0,
      limit: 20,
      file: [],
      dialogVisible: false,
      action: 'https://api.ontuotu.com/api/general/upload',
      form: {},
      addressList: [],
      city,
      props: {
        label: 'name',
        value: 'id'
      },
      options: [
        { label: "待总集复核", value: "a9aa18ff-1f2c-46a3-b816-1ed227d960b6" },
        { label: "审批中", value: "52efb014-07cf-41ec-8407-13e151f95da6" },
        { label: "审批成功", value: "7c970bbb-0744-4f99-813b-d7bd98188a71" },
        { label: "审批驳回", value: "1a5b7046-c33d-42c1-92ef-35e5cea1a9a2" }
      ]
    };
  },
  mounted () {
    this.getOrderList();
    this.online();
  },
  methods: {
    findStatusLabel (value) {
      if (!value) return '待处理';
      const target = this.options.find(item => item.value === value);
      return target ? target.label : '处理中';
    },
    getStatusClass (value) {
      if (value === '7c970bbb-0744-4f99-813b-d7bd98188a71') return 'badge-approved';
      if (value === '1a5b7046-c33d-42c1-92ef-35e5cea1a9a2') return 'badge-rejected';
      return 'badge-reviewing';
    },
    async online () {
      try {
        const { result } = await online({
          page: 1,
          limit: 100,
          keyword: '',
          select_option: '',
          form_head_uuid: '0f5b2fde26c04882a5d6c5c885a30a3f',
        });
        this.addressList = Array.isArray(result) ? result : [];
      } catch (e) {
        this.addressList = [];
      }
    },
    changeAddress (e) {
      let obj = this.addressList.find(item => item.id === e);
      if (!obj) return;
      this.form.etnsg3kbzcknkawr = obj.xejhteu0ub3fd3eh || '';
      this.form['5swsm1dvrchwdg3v'] = obj['9simp0sjii9s0m33'] || '';
      this.form.glhztcnef0v5zdcy = Array.isArray(obj.b3ccmzbfyzlwy9sc) ? obj.b3ccmzbfyzlwy9sc.map(el => el.id) : [];
    },
    async getOrderList () {
      this.loading = true;
      try {
        const { form_head_uuid, page, limit } = this;
        const { meta, result } = await online({
          form_head_uuid,
          page,
          limit,
          keyword: "",
          select_option: "",
        });
        this.orderList = Array.isArray(result) ? result : [];
        this.total = meta && meta.total ? meta.total : 0;
      } catch (e) {
        console.error("加载标外商品申请失败:", e);
        this.orderList = [];
      } finally {
        this.loading = false;
      }
    },
    handleCurrentChange (page) {
      this.page = page;
      this.getOrderList();
    },
    handleSizeChange (limit) {
      this.page = 1;
      this.limit = limit;
      this.getOrderList();
    },
    handleOpen () {
      this.form = {};
      this.file = [];
      this.dialogVisible = true;
    },
    handleSuccess ({ result }) {
      this.file.push(result);
    },
    handleRemove (file) {
      let i = this.file.findIndex(el => el.id === file.id);
      if (i !== -1) {
        this.file.splice(i, 1);
      }
    },
    async submit () {
      const { form, file } = this;
      const validations = [
        { field: 'yweggjdjennwlx2b', error: '请输入商品名称' },
        { field: 'wxym5do3isvbzeth', error: '请输入预计单价' },
        { field: '2lcyfkgbyjmfmedh', error: '请输入需求数量' },
        { field: 'g9llk5yvei0jvr6x', error: '请输入申请理由采购原因' },
      ];
      for (const { field, error } of validations) {
        if (!form[field]) {
          return this.$message.warning(error);
        }
      }
      this.submitLoading = true;
      try {
        const { form_head_uuid } = this;
        if (file && file.length > 0) {
          form.xrsnsamzcsuibskx = file.map(el => el.id);
        }
        await postOnline(
          {
            form_head_uuid,
            ...this.form,
          },
          { suppressErrorNotification: true }
        );
        this.$message.success('标外商品申请已提交');
        this.dialogVisible = false;
        this.page = 1;
        this.getOrderList();
      } catch (e) {
        this.$message.error('提交失败，请稍后重试');
      } finally {
        this.submitLoading = false;
      }
    }
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';

.commodity-application-container {
  width: 100%;

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f1f5f9;

    .header-left {
      display: flex;
      align-items: baseline;
      gap: 12px;

      .title {
        font-size: 16px;
        font-weight: 700;
        color: #0f172a;
        margin: 0;
      }

      .sub-title {
        font-size: 13px;
        color: #64748b;
      }
    }

    .btn-create {
      background-color: @brandPrimary;
      border-color: @brandPrimary;
      font-weight: 600;
      padding: 9px 18px;
      border-radius: 6px;

      &:hover {
        background-color: @brandSecondary;
        border-color: @brandSecondary;
      }
    }
  }

  /* 骨架屏 */
  .order-skeleton-list {
    display: flex;
    flex-direction: column;
    gap: 14px;

    .sk-order-card {
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      padding: 16px;
      background: #fff;

      .sk-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 14px;
        padding-bottom: 10px;
        border-bottom: 1px dashed #f1f5f9;
      }

      .sk-details {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      .sk-bar {
        height: 16px;
        border-radius: 4px;
        background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
        background-size: 200% 100%;
        animation: sk-shimmer 1.5s infinite;

        &.w-20 { width: 20%; }
        &.w-30 { width: 30%; }
        &.w-40 { width: 40%; }
        &.w-60 { width: 60%; }
      }
    }
  }

  @keyframes sk-shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  /* 表头 */
  .orderTableHeader {
    width: 100%;
    height: 42px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px 6px 0 0;
    color: #475569;
    font-size: 13px;
    font-weight: 600;
    display: flex;
    align-items: center;

    span {
      text-align: center;

      &.col-status { width: 120px; }
      &.col-goods { flex: 1; text-align: left; padding-left: 20px; }
      &.col-spec { width: 150px; }
      &.col-price { width: 120px; }
      &.col-reason { width: 220px; }
    }
  }

  /* 列表 */
  .orderList {
    width: 100%;
    list-style: none;
    padding: 0;
    margin: 0;

    .order-card-item {
      border: 1px solid #e2e8f0;
      border-top: none;
      background: #ffffff;
      transition: all 0.2s ease;
      margin-bottom: 10px;
      border-radius: 0 0 6px 6px;

      &:hover {
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
      }

      .orderDetail {
        display: flex;
        align-items: center;
        padding: 14px 16px;

        .col-status {
          width: 120px;
          text-align: center;
          flex-shrink: 0;

          .status-badge {
            font-size: 12px;
            padding: 2px 8px;
            border-radius: 4px;
            font-weight: 600;

            &.badge-reviewing {
              background: #eff6ff;
              color: @brandPrimary;
              border: 1px solid #bfdbfe;
            }

            &.badge-approved {
              background: #ecfdf5;
              color: #10b981;
              border: 1px solid #a7f3d0;
            }

            &.badge-rejected {
              background: #fef2f2;
              color: #ef4444;
              border: 1px solid #fecaca;
            }
          }
        }

        .goodsName {
          flex: 1;
          padding: 0 20px;

          .goods-title {
            margin: 0 0 4px;
            font-size: 13px;
            font-weight: 600;
            color: #0f172a;
          }

          .brand-text {
            font-size: 11px;
            color: #64748b;
          }
        }

        .col-spec {
          width: 150px;
          text-align: center;
          font-size: 13px;
          color: #475569;
          flex-shrink: 0;
        }

        .col-price {
          width: 120px;
          text-align: center;
          font-size: 13px;
          font-weight: 700;
          color: #0f172a;
          flex-shrink: 0;
        }

        .col-reason {
          width: 220px;
          font-size: 12px;
          color: #64748b;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: center;
          flex-shrink: 0;
        }
      }
    }
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    margin: 20px 0 0;
  }

  /* 图片列表 */
  .fileList {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .fileItem {
      width: 68px;
      height: 68px;
      border-radius: 6px;
      position: relative;
      border: 1px solid #e2e8f0;
      overflow: hidden;

      .url {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .close {
        position: absolute;
        top: 2px;
        right: 2px;
        width: 16px;
        height: 16px;
        background: rgba(0,0,0,0.6);
        color: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        cursor: pointer;
      }

      &.uploader {
        border: 1px dashed #cbd5e1;
        display: flex;
        align-items: center;
        justify-content: center;

        /deep/ .el-upload--picture-card {
          width: 68px;
          height: 68px;
          line-height: 68px;
          border: none;
          background: transparent;
        }
      }
    }
  }

  /* 空状态 */
  .empty-gov-state {
    padding: 60px 0;
    text-align: center;
    background: #ffffff;
    border: 1px dashed #cbd5e1;
    border-radius: 8px;
    margin-top: 16px;

    .icon-circle {
      width: 60px;
      height: 60px;
      margin: 0 auto 14px;
      border-radius: 50%;
      background: #eff6ff;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 28px;
        color: @brandPrimary;
      }
    }

    .empty-title {
      font-size: 15px;
      font-weight: 600;
      color: #334155;
      margin: 0 0 6px;
    }

    .empty-sub {
      font-size: 13px;
      color: #94a3b8;
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/client/CommodityApplication.vue